import { declareString } from "@1js/localization";

export const CheckAccuracyWarningLabelTitle = declareString(
  "promptLibrary.detailCheckAccuracyWarningLabelTitle",
  {
    text: "Someone else wrote this prompt.",
    comment: "Label for warning that appears on a user authored prompt",
  }
);

export const CheckAccuracyWarningLabelContent = declareString(
  "promptLibrary.detailCheckAccuracyWarningLabelContent",
  {
    text: "Check for accuracy before sending to Copilot.",
    comment: "Label for warning that appears on a user authored prompt",
  }
);
